import { API_URLS } from "service/url";
import {  Project, ProjectDetailResponse } from "../../../types/project";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectById = async (
  projectUuid: string
): Promise<Project> => {
  try {
    const { data } = await axiosInstance.get<ProjectDetailResponse>(
      `${API_URLS.PROJECT_BY_ID}/${projectUuid}`
    );
   
     return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};

